document.addEventListener('DOMContentLoaded', () => {
  const main = document.querySelector('.main-content');
  const homepageOrder = [
    '.hero',
    '.homepage-products-section',
    '.homepage-scenes-section',
    '.story-band',
    '.homepage-trust-section'
  ];

  const sortHomepageSections = () => {
    if (!main) return;

    const orderedSections = homepageOrder
      .map((selector, index) => {
        const section = Array.from(main.children).find((item) => item.matches('.shopify-section') && item.querySelector(selector));
        return section ? { section, index } : null;
      })
      .filter(Boolean);

    if (orderedSections.length < 2) return;
    orderedSections
      .sort((a, b) => a.index - b.index)
      .forEach(({ section }) => main.appendChild(section));
  };

  sortHomepageSections();
  document.addEventListener('shopify:section:load', sortHomepageSections);

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-toggle]');
    if (!toggle) return;

    const header = toggle.closest('[data-site-header]');
    if (!header) return;

    const open = header.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
  });

  const headerSearch = document.querySelector('[data-header-search]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchInput = document.querySelector('[data-header-search-input]');
  const searchForm = document.querySelector('[data-header-search-form]');

  if (headerSearch && searchToggle && searchInput && searchForm) {
    const openSearch = () => {
      headerSearch.classList.add('is-active');
      searchToggle.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(() => searchInput.focus());
    };

    const closeSearch = () => {
      headerSearch.classList.remove('is-active');
      searchToggle.setAttribute('aria-expanded', 'false');
    };

    searchToggle.addEventListener('click', () => {
      if (headerSearch.classList.contains('is-active')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    searchForm.addEventListener('submit', (event) => {
      if (!searchInput.value.trim()) {
        event.preventDefault();
        openSearch();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && headerSearch.classList.contains('is-active')) {
        closeSearch();
        searchToggle.focus();
      }
    });

    document.addEventListener('click', (event) => {
      if (!headerSearch.contains(event.target) && headerSearch.classList.contains('is-active')) {
        closeSearch();
      }
    });
  }

  const footerMenuQuery = window.matchMedia('(min-width: 600px)');
  const syncFooterMenus = () => {
    const footerMenus = document.querySelectorAll('[data-footer-menu]');
    const desktop = footerMenuQuery.matches;

    footerMenus.forEach((menu) => {
      if (desktop) {
        menu.setAttribute('open', '');
      } else {
        menu.removeAttribute('open');
      }
    });
  };

  syncFooterMenus();
  footerMenuQuery.addEventListener('change', syncFooterMenus);
  document.addEventListener('shopify:section:load', syncFooterMenus);

  const revealItems = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    revealItems.forEach((item) => observer.observe(item));
  }

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    const panels = gallery.querySelectorAll('[data-gallery-panel]');

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = thumb.dataset.mediaIndex;

        thumbs.forEach((item) => {
          const isActive = item.dataset.mediaIndex === index;
          item.classList.toggle('is-active', isActive);
          if (isActive) {
            item.setAttribute('aria-current', 'true');
          } else {
            item.removeAttribute('aria-current');
          }
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.mediaIndex === index;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });
  });

  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartSubtotal = document.querySelector('[data-cart-subtotal]');
  const cartStatus = document.querySelector('[data-cart-status]');
  const cartCounts = document.querySelectorAll('[data-cart-count]');
  const cartOpeners = document.querySelectorAll('[data-cart-open]');
  const cartClosers = document.querySelectorAll('[data-cart-close]');

  const formatMoney = (cents) => {
    const value = Number(cents || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    }).format(value);
  };

  const escapeHTML = (value) => {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  };

  const setCartStatus = (message) => {
    if (!cartStatus) return;
    cartStatus.textContent = message || '';
  };

  const openCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
  };

  const closeCartDrawer = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
  };

  const renderCartItem = (item, index) => {
    const productTitle = escapeHTML(item.product_title);
    const variantTitle = escapeHTML(item.variant_title);
    const image = item.image
      ? `<img src="${item.image}" alt="${productTitle}" loading="lazy">`
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__variant">${variantTitle}</p>`
      : '';

    return `
      <article class="cart-drawer__item" data-cart-item data-line="${index + 1}">
        <a class="cart-drawer__image" href="${item.url}">${image}</a>
        <div class="cart-drawer__item-body">
          <a class="cart-drawer__item-title" href="${item.url}">${productTitle}</a>
          ${variant}
          <div class="cart-drawer__item-meta">
            <div class="cart-drawer__quantity">
              <button type="button" data-cart-qty-minus aria-label="Decrease quantity">-</button>
              <input type="number" min="0" value="${item.quantity}" data-cart-qty aria-label="Quantity for ${productTitle}">
              <button type="button" data-cart-qty-plus aria-label="Increase quantity">+</button>
            </div>
            <span class="cart-drawer__line-price">${formatMoney(item.final_line_price)}</span>
          </div>
        </div>
      </article>
    `;
  };

  const renderCart = (cart) => {
    cartCounts.forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (!cartItems) return;

    if (cart.item_count === 0) {
      cartItems.innerHTML = `
        <div class="cart-drawer__empty">
          <h3>Your cart is empty</h3>
          <p>Add a bedtime essential to continue.</p>
        </div>
      `;
      if (cartFooter) cartFooter.hidden = true;
      return;
    }

    cartItems.innerHTML = cart.items.map(renderCartItem).join('');
    if (cartFooter) cartFooter.hidden = false;
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
  };

  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());

  const changeCartLine = (line, quantity) => {
    setCartStatus('Updating cart...');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    })
      .then((response) => response.json())
      .then((cart) => {
        renderCart(cart);
        setCartStatus('Cart updated.');
      })
      .catch(() => setCartStatus('Could not update cart. Please try again.'));
  };

  cartOpeners.forEach((opener) => {
    opener.addEventListener('click', (event) => {
      if (!cartDrawer) return;
      event.preventDefault();
      fetchCart().then(renderCart).finally(openCartDrawer);
    });
  });

  cartClosers.forEach((closer) => closer.addEventListener('click', closeCartDrawer));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCartDrawer();
  });

  if (cartItems) {
    cartItems.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-qty-minus], [data-cart-qty-plus]');
      if (!button) return;

      const item = button.closest('[data-cart-item]');
      const input = item && item.querySelector('[data-cart-qty]');
      if (!item || !input) return;

      const line = Number(item.dataset.line);
      const current = Number(input.value) || 0;
      const next = button.matches('[data-cart-qty-plus]') ? current + 1 : Math.max(0, current - 1);
      input.value = next;
      changeCartLine(line, next);
    });

    cartItems.addEventListener('change', (event) => {
      const input = event.target.closest('[data-cart-qty]');
      if (!input) return;

      const item = input.closest('[data-cart-item]');
      if (!item) return;
      changeCartLine(Number(item.dataset.line), Math.max(0, Number(input.value) || 0));
    });
  }

  document.querySelectorAll('form[action*="/cart/add"], form.product-form').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!cartDrawer) return;

      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const previousHTML = submit ? submit.innerHTML : '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Adding...';
      }
      setCartStatus('Adding item...');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          return fetchCart();
        })
        .then((cart) => {
          renderCart(cart);
          setCartStatus('Added to cart.');
          openCartDrawer();
        })
        .catch(() => {
          setCartStatus('Could not add this item. Please try again.');
        })
        .finally(() => {
          if (submit) {
            submit.disabled = false;
            submit.innerHTML = previousHTML;
          }
        });
    });
  });
});
